import {Rectangle} from "vue2-google-maps";

export class MarkerOptions {
  constructor(options) {
    this.text = options.text || 'Label';
    this.textColor = options.textColor || '#ffffff';
    this.backgroundColor = options.backgroundColor || '#ff0000';
    this.borderColor = options.borderColor || '#000000';
  }
}
export class DrawingSerializeUI {
  constructor(ui) {
    this.type = ui.type || ''; // 'rectangle', 'polygon', 'ellipse'
    if (ui.type === 'rectangle') {
      this.bounds = ui.bounds || []; // [lng1, lat1, lng2, lat2]
    } else if (ui.type === 'polygon') {
      this.paths = ui.paths || []; // [{lat, lng}, ...]
    } else if (ui.type === 'ellipse') {
      this.latLngBounds = ui.latLngBounds || { sw: { lat:0, lng:0 }, ne: { lat:0, lng:0 } }; // {sw:{lat,lng}, ne:{lat,lng}}
    }
    this.fillColor = ui.fillColor || '#ff0000ff'; // 8자리 hex 색상
    this.strokeColor = ui.strokeColor || '#ff0000ff'; // 8자리 hex 색상
    this.baseCenter = ui.baseCenter || { lat:0, lng:0 }; // 도형의 기본 중심 좌표 {lat, lng}
  }
}
export class DrawingSerializeData {
  constructor(data) {
    this.id = data.id || null; // DB 저장용 고유 ID
    this.fieldId = data.fieldId || '';
    this.fieldName = data.fieldName || '';
    this.text = data.text || 'Label';
    this.description = data.description || '';
    this.eventType = data.eventType || 'enter'; // 'enter', 'overstay'
    this.stayTime = data.stayTime || '00:10:00'; // 체류시간: '00:10:00'
    this.useBarrierOverlay = false; // 기준 영역 사용 여부
    this.etc = data.etc || {}; // 기타 정보 (추가정보)
  }
}
export class DrawingSerialize {
  constructor(serialize) {
    this.ui = new DrawingSerializeUI(serialize && serialize.ui || {});
    this.data = new DrawingSerializeData(serialize && serialize.data || {});
  }
}


export default class DrawingHandler {
  constructor(map, options) {
    this.map = map;
    this.addedOverlay = () => {}; // 도형 추가 콜백
    this.changedOverlayPosition = () => {}; // 도형 위치 변경 콜백
    this.changedOverlayShape = () => {}; // 도형 모양 변경 콜백
    this.setSelectOverlay = () => {}; // 선택된 도형 설정 콜백
    this.outOfRange = () => {
      alert("기준 영역을 벗어날 수 없습니다!");
    };

    this.options = {
      ...options || { readonly: false }
    }


    naver.maps.Event.once(this.map, 'init', () => {
      this.__initDrawingManager();
    });

    // 맵 클릭 시 도형 선택 해제
    naver.maps.Event.addListener(this.map, 'click', () => {
      if (this.drawingManager.drawingMode === naver.maps.drawing.DrawingMode.HAND) {
        if (this.setSelectOverlay) {
          this.setSelectOverlay(null);
        }
      }
    });
  }

  // DrawingManager 초기화
  __initDrawingManager () {
    this.drawingManager = new naver.maps.drawing.DrawingManager({
      map: this.map,
      drawingControl: false,
      rectangleOptions: {
        fillColor: '#ff0000',
        fillOpacity: 0.5,
        strokeWeight: 3,
        strokeColor: '#ff0000'
      },
      ellipseOptions: {
        fillColor: '#ff25dc',
        fillOpacity: 0.5,
        strokeWeight: 3,
        strokeColor: '#ff25dc'
      },
      polygonOptions: {
        fillColor: '#ffc300',
        fillOpacity: 0.5,
        strokeWeight: 3,
        strokeColor:'#ffc300'
      },
    });

    if (this.options && this.options.readonly) {
      this.drawingManager.setOptions({ drawingMode: null })
    }

    this.drawingManager.addListener(naver.maps.drawing.DrawingEvents.ADD, (overlay, serialize) => {
      if (!this._overlays) this._overlays = []
      this._overlays.push(overlay)

      if (serialize) {
        overlay.serialize = serialize;
      }

      const text = serialize && serialize.data && serialize.data.text ? serialize.data.text : undefined;
      this.__addMarker(this.map, overlay, text);
      this.__updateMarkerPosition(overlay);

      let _serialize = this.__serializeOverlay(overlay)
      if (!serialize) {
        overlay.serialize = _serialize;
      }

      if (overlay.serialize.data.id) {
        overlay.setOptions({
          strokeStyle: 'solid',
        });
      } else {
        overlay.setOptions({
          strokeStyle: 'dash',
        });
      }

      // this.barrierOverlay 가 있을 경우, this.barrierOverlay 영역을 벗어나지 못하게 처리
      if (this.barrierOverlay && !overlay.serialize.data.useBarrierOverlay) {
        const points = this.__getPoints(overlay);
        const valid = points.every(p => this.__isPointInsideShape(p, this.barrierOverlay));
        if (!valid) {
          if (this.outOfRange) {
            this.outOfRange();
          } else {
            alert("기준 영역을 벗어날 수 없습니다!");
          }
          overlay._marker.setMap(null);
          overlay.setMap(null);
        } else {
          overlay.barrierOverlay = this.barrierOverlay;
          this.addedOverlay(overlay, _serialize);
        }
      } else {
        this.addedOverlay(overlay, serialize || _serialize);
      }

      naver.maps.Event.addListener(overlay, "mouseup", (data) => {
        overlay._point_end = data.point

        // 도형의 위치가 변경될 경우 호출
        const ps = overlay._point_start;
        const pe = overlay._point_end;
        if (ps && pe && !(ps.x === pe.x && ps.y === pe.y)) {
          const points = this.__getPoints(overlay);
          const movedPoints = points.map(p => {
            const projection = this.map.getProjection();
            const point = projection.fromCoordToPoint(new naver.maps.LatLng(p.lat, p.lng));
            const dx = pe.x - ps.x;
            const dy = pe.y - ps.y;
            point.x += dx;
            point.y += dy;
            const newCoord = projection.fromPointToCoord(point);
            return { lat: newCoord.y, lng: newCoord.x };
          });
          this.checkInsideTarget(overlay, movedPoints)
        } else {
          const serialize = this.__serializeOverlay(overlay)
        }

      });
      naver.maps.Event.addListener(overlay, "mousedown", (data) => {
        if (overlay.serialize.data.useBarrierOverlay) {
          if (naver.maps.Event.stopPropagation) {
            naver.maps.Event.stopPropagation();
          }
        }
        overlay._point_start = data.point
        overlay._point_end = null;
        this.__updateMarkerPosition(overlay);
      });
      naver.maps.Event.addListener(overlay, "bounds_changed", (data) => {
        // 원형, 사각형 의 bounds 변경시
        overlay._point_start = null;
        this.__updateMarkerPosition(overlay)

        // 도형 크기 조절이 아닌 이동 후에도 호출되므로, 중복 실행을 막기 위해 isMovedType 으로 단계를 나눔 (overflow -> restored -> moved)
        // overflow: 경계 밖으로 이동 시도시 강제 이동
        // restored: overflow 로 인해 실행됨
        // moved: 정상적인 이동
        if (overlay.isMovedType === 'overflow') {
          overlay.isMovedType = 'restored';
        } else {
          if (overlay.isMovedType === 'restored') {
            overlay.isMovedType = 'moved';
          } else {
            const sw = { lat: data._min.y, lng: data._min.x };
            const ne = { lat: data._max.y, lng: data._max.x };
            const nw = { lat: data._max.y, lng: data._min.x };
            const se = { lat: data._min.y, lng: data._max.x };
            const points = [sw, nw, ne, se];
            this.checkInsideTarget(overlay, points);
          }
        }
      });

      if (overlay instanceof naver.maps.Polygon) {
        try {
          const paths = overlay.getPaths(); // KVOArray 반환
          if (paths && paths.getLength() > 0) {
            const path = paths.getAt(0); // 첫 번째 path (KVOArray)
            // 점 위치 변경
            naver.maps.Event.addListener(path, 'set_at', (index, item) => {

              this.__updateMarkerPosition(overlay);
            });
          }
        } catch (error) {
          console.warn('KVO 이벤트 등록 실패:', error);
        }
      }

      // 외부에서 label 및 색상을 업데이트할 수 있도록 함수 등록
      overlay.update = (serialize) => {
        if (!serialize) return;
        overlay.serialize = serialize

        // 도형 옵션 업데이트
        if (serialize.ui) {
          if (serialize.ui.fillColor) {
            const color = this.__getAlphaFromHex(serialize.ui.fillColor);
            overlay.setOptions({
              fillColor: color.hex,
              fillOpacity: color.alpha
            });
          }

          if (serialize.ui.strokeColor) {
            const color = this.__getAlphaFromHex(serialize.ui.strokeColor);
            overlay.setOptions({
              strokeColor: color.hex,
              strokeOpacity: color.alpha
            });
          }
        }

        if (serialize.data.id) {
          overlay.setOptions({
            strokeStyle: 'solid',
          });
        } else {
          overlay.setOptions({
            strokeStyle: 'dash',
          });
        }

        // 마커 옵션 업데이트 (실제 UI 반영은 __updateMarkerPosition 에서 처리)
        if (overlay._marker) {
          const markerOptions = overlay._marker.options;
          if (serialize.data && serialize.data.text) {
            markerOptions.text = serialize.data.text;
          }
          if (serialize.ui && serialize.ui.strokeColor) {
            if (serialize.ui.strokeColor) {
              markerOptions.borderColor = serialize.ui.strokeColor;
              markerOptions.textColor = this.__getContrastColor(serialize.ui.strokeColor);
              markerOptions.borderColor = this.__getContrastColor(serialize.ui.strokeColor);
              markerOptions.backgroundColor = serialize.ui.strokeColor;
            }
          }
          overlay._marker.options = markerOptions;
          this.__updateMarkerPosition(overlay);
        }

      };
    });
    this.drawingManager.addListener(naver.maps.drawing.DrawingEvents.SELECT, (overlay) => {
      // 선택 했을 때, 현재 상태를 저장
      if (overlay.getPath) overlay.oldPath = overlay.getPath()
      if (overlay.getBounds) overlay.oldBounds = overlay.getBounds()

      const serializeOverlay = this.__serializeOverlay(overlay)
      if (this.setSelectOverlay) {
        this.setSelectOverlay(overlay, serializeOverlay)
      }
    });

    this.drawingManager.addListener(naver.maps.drawing.DrawingEvents.REMOVE, (overlay) => {
      if (overlay._marker) {
        overlay._marker.setMap(null);
        overlay._marker = null;
      }
      if (this.setSelectOverlay) {
        this.setSelectOverlay(null)
      }
    });
  }
  // 도형에 마커(라벨) 추가
  __addMarker(map, overlay, text = 'Label' ) {
    const position = this.__getOverlayCenter(overlay);
    const strokeColor = this.__getOverlayColor(overlay, 'stroke');
    const textColor = this.__getContrastColor(strokeColor);
    const borderColor= this.__getContrastColor(strokeColor);
    const backgroundColor = strokeColor;

    const markerOptions = new MarkerOptions({ text, textColor, backgroundColor, borderColor })
    const marker = new naver.maps.Marker({
      position,
      map,
      icon: {
        content: this.__makeLabelContent(markerOptions),
        anchor: new naver.maps.Point(30, 30)
      },
      clickable: true
    });
    marker.options = markerOptions;

    // 마커 클릭 시 overlay 선택 처리
    naver.maps.Event.addListener(marker, "click", () => {
      // DrawingManager의 select 이벤트 강제 트리거
      this.drawingManager.trigger(naver.maps.drawing.DrawingEvents.SELECT, overlay);
    });

    // overlay에 marker와 helper 메서드 저장
    overlay._marker = marker;

    return marker;
  }
  // 8자리 hex 색상에서 알파값 추출 (0~1 사이)
  __getAlphaFromHex(hex) {
    hex = hex.replace("#", "");
    if (hex.length === 8) {
      const a = hex.substring(6, 8); // 마지막 2자리
      const alpha = parseInt(a, 16) / 255; // 0~1 사이 값
      return { hex: `#${hex.substring(0, 6)}`, alpha }
    }
    return { hex:`#${hex}`, alpha: 1.0 }
  }
  // 입력한 색상에 대해 대비되는 텍스트 색상 반환 (흰색 또는 검은색)
  __getContrastColor(hex) {
    // # 제거
    hex = hex.replace('#', '');

    // RGB 값 추출
    let r = parseInt(hex.substring(0,2), 16);
    let g = parseInt(hex.substring(2,4), 16);
    let b = parseInt(hex.substring(4,6), 16);

    // 밝기 계산 (perceived luminance)
    let luminance = (0.299 * r + 0.587 * g + 0.114 * b);

    // 밝기 기준으로 텍스트 색상 선택
    return luminance > 186 ? '#000' : '#fff';
  }
  // 도형의 채우기 또는 선 색상과 투명도 결합하여 8자리 hex 색상 반환
  __getOverlayColor(overlay, type = 'fill') {
    if (type === 'fill') {
      const alpha = overlay.getOptions().fillOpacity;
      return overlay.getOptions().fillColor + Math.floor(alpha * 255).toString(16).padStart(2, '0');
    } else if (type === 'stroke') {
      const alpha = overlay.getOptions().strokeOpacity;
      return overlay.getOptions().strokeColor + Math.floor(alpha * 255).toString(16).padStart(2, '0');
    }
    return '#000000'; // 기본값
  }
  // 헬퍼 함수: HTML content 생성
  __makeLabelContent(markerOptions) {
    const text = markerOptions.text
    const textColor = markerOptions.textColor
    const backgroundColor = markerOptions.backgroundColor
    const borderColor = markerOptions.borderColor
    return `
    <div style="
      background:${backgroundColor};
      border:2px solid ${borderColor};
      border-radius:6px;
      padding:4px 8px;
      font-size:12px;
      font-weight:bold;
      text-align:center;
      white-space:nowrap;
      color:${textColor};
    ">
      ${text}
    </div>
  `;
  }
  // 헬퍼 함수: 다각형의 중심 좌표 계산
  __getPolygonCenter(path) {
    let x = 0, y = 0;
    path.forEach(p => {
      x += p.x;
      y += p.y;
    });
    return new naver.maps.LatLng(y / path.length, x / path.length);
  }
  // 헬퍼 함수: 도형의 중심 좌표 반환
  __getOverlayCenter(overlay) {
    if (overlay instanceof naver.maps.Circle) {
      return overlay.getCenter();
    }
    if (overlay instanceof naver.maps.Rectangle) {
      const bounds = overlay.getBounds();
      return bounds.getCenter();
    }
    if (overlay instanceof naver.maps.Polygon) {
      const path = overlay.getPath();
      return this.__getPolygonCenter(path); // 직접 계산 필요
    }
    if (overlay instanceof naver.maps.Polyline) {
      const path = overlay.getPath();
      return path[Math.floor(path.length / 2)]; // 중간 지점
    }
  }
  // 도형 변경 시 마커 위치 및 내용 업데이트
  __updateMarkerPosition(overlay) {
    const marker = overlay._marker;
    if (!marker) return;

    const markerOptions = marker.options;

    // 새 content
    const content = this.__makeLabelContent(markerOptions);

    // 임시 div로 크기 측정
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.visibility = "hidden";
    tempDiv.innerHTML = content;
    document.body.appendChild(tempDiv);

    const width = tempDiv.offsetWidth;
    const height = tempDiv.offsetHeight;
    document.body.removeChild(tempDiv);

    // anchor를 가운데로 이동 (px 단위)
    const anchor = new naver.maps.Point(width / 2, height / 2);

    // 마커 업데이트 (content/anchor만 갱신)
    marker.setIcon({
      content,
      anchor
    });

    // 📌 중심 좌표 계산 (__updateMarkerPosition 로직 참고)
    const projection = this.map.getProjection();
    const baseCenter = this.__getOverlayCenter(overlay);
    const centerPoint = projection.fromCoordToPoint(baseCenter);
    if (overlay.serialize) {
      overlay.serialize.ui.baseCenter = { lat: baseCenter.y, lng: baseCenter.x };
    }

    const startPos = overlay._point_start;
    const endPos = overlay._point_end || startPos;

    if (startPos && endPos) {
      const dx = endPos.x - startPos.x;
      const dy = endPos.y - startPos.y;
      centerPoint.x += dx;
      centerPoint.y += dy;
    }

    const newCenter = projection.fromPointToCoord(centerPoint);

    // 📌 이동 보정된 좌표로 마커 위치 업데이트
    marker.setPosition(newCenter);

    // 마커의 정보가 변경될 경우 serialize 업데이트
    const serialize = this.__serializeOverlay(overlay)
  }
  __restoreOverlayPosition(overlay) {
    if (!overlay) return;

    // (overlay 타입에 따라 center, path, bounds 등 다르게 복원해야 함)
    if (overlay instanceof naver.maps.Rectangle) {
      overlay.isMovedType = 'overflow';
    }
    overlay.oldBounds = overlay.getBounds ? overlay.getBounds() : null;
    overlay.oldCenter = overlay.getCenter ? overlay.getCenter() : null;
    overlay.oldPath = overlay.getPath ? overlay.getPath().getArray() : null;

    const overlayType = overlay instanceof naver.maps.Marker ? 'Marker' :
      overlay instanceof naver.maps.Polygon ? 'Polygon' :
        overlay instanceof naver.maps.Polyline ? 'Polyline' :
          overlay instanceof naver.maps.Rectangle ? 'Rectangle' :
            overlay instanceof naver.maps.Circle ? 'Circle' :
              overlay instanceof naver.maps.Ellipse ? 'Ellipse' : null;

    if (!overlayType) return;

    setTimeout(() => {
      switch (overlayType) {
        case 'Marker':
        case 'Circle': // Circle은 center로 이동
          overlay.setCenter(overlay.oldCenter);
          break;
        case 'Polyline':
        case 'Polygon':
          overlay.setPath(overlay.oldPath);
          break;
        case 'Rectangle':
        case 'Ellipse': // Rectangle, Ellipse는 bounds로 이동
          overlay.setBounds(overlay.oldBounds);
          break;
      }
      this.__updateMarkerPosition(overlay);
    }, 100)
  }

  // 선택한 도형의 데이터를 가져온다 (DB 저장용)
  __serializeOverlay(overlay) {
    const serialize = overlay.serialize || new DrawingSerialize();
    if (overlay._marker.options.text) {
      serialize.data.text = overlay._marker.options.text;
    }

    // 다각형
    if (overlay instanceof naver.maps.Polygon) {
      const pathMVC = overlay.getPath && overlay.getPath();
      const pathArr = (pathMVC && typeof pathMVC.getArray === 'function') ? pathMVC.getArray() : (Array.isArray(pathMVC) ? pathMVC : []);
      serialize.ui.type = 'polygon';
      serialize.ui.paths = pathArr.map(p => this.__latLngToPlain(p));
    }

    // 타원
    else if (overlay instanceof naver.maps.Ellipse) {
      serialize.ui.type = 'ellipse';
      serialize.ui.latLngBounds = this.__latLngBoundsToPlain(overlay.getBounds && overlay.getBounds())
    }

    // 사각형
    else if (overlay instanceof naver.maps.Rectangle) {
      serialize.ui.type = 'rectangle';
      serialize.ui.bounds = this.__boundsToPlain(overlay.getBounds && overlay.getBounds())
    }

    serialize.ui.fillColor = this.__getOverlayColor(overlay, 'fill');
    serialize.ui.strokeColor = this.__getOverlayColor(overlay, 'stroke');

    return serialize
  }
  // 다양한 LatLng 표현을 {lat,lng} 형태의 plain object 로 변환
  __latLngToPlain(latlng) {
    if (!latlng) return null;

    // 객체에 toJSON()이 있으면 우선 사용
    if (typeof latlng.toJSON === 'function') {
      const j = latlng.toJSON(); // 네이버는 {y, x} 또는 {lat, lng} 형태일 수 있음
      if ('lat' in j && 'lng' in j) return { lat: j.lat, lng: j.lng };
      if ('y' in j && 'x' in j) return { lat: j.y, lng: j.x };
      return j; // fallback
    }

    // 메서드 기반 (lat(), lng())
    if (typeof latlng.lat === 'function' && typeof latlng.lng === 'function') {
      return { lat: latlng.lat(), lng: latlng.lng() };
    }

    // plain object {lat,lng} 또는 {y,x}
    if ('lat' in latlng && 'lng' in latlng) return { lat: latlng.lat, lng: latlng.lng };
    if ('y' in latlng && 'x' in latlng) return { lat: latlng.y, lng: latlng.x };

    // 배열 [lat, lng]
    if (Array.isArray(latlng) && latlng.length >= 2) return { lat: latlng[0], lng: latlng[1] };

    return null;
  }
  // 다양한 Bounds 표현을 number[], 또는 {lat,lng}[] 형태의 plain Array 로 변환
  __boundsToPlain(bounds) {
    if (!bounds) return null;
    if (bounds.getMax && bounds.getMin) {
      return [
        ...Object.values(bounds.getMax()),
        ...Object.values(bounds.getMin())
      ]
    }
  }
  __latLngBoundsToPlain(bounds) {
    if (!bounds) return null;
    if (bounds instanceof naver.maps.LatLngBounds) {
      return {
        sw: this.__latLngToPlain(bounds.getSW()),
        ne: this.__latLngToPlain(bounds.getNE())
      }
    }
    if (bounds.getMax && bounds.getMin) {
      return {
        sw: this.__latLngToPlain(bounds.getMin()),
        ne: this.__latLngToPlain(bounds.getMax())
      }
    }
  }

  /**
   * 도형 그리기 모드 설정
   * @param mode - naver.maps.drawing.OverlayType.*
   */
  setDrawingMode(mode) {
    this.drawingManager.setOptions("drawingMode", mode);
  }

  /**
   * 도형 삭제
   * @param overlay
   */
  deleteOverlay(overlay) {
    this.drawingManager.removeDrawing(overlay);
  }

  /**
   * 도형 추가
   */
  // serialize = { ui: {type, paths/bounds/latLngBounds, fillColor, strokeColor}, data: {fieldId, fieldName, text, description} } as DrawingSerialize
  addOverlay(serialize) {
    if (!serialize || !serialize.ui || !serialize.ui.type) {
      console.warn("도형 타입이 없습니다.", serialize);
      return;
    }
    // 도형 타입에 따라 분기
    // 각 분기에서 naver.maps.drawing.DrawingEvents.ADD 를 트리거하여 공통 로직 처리
    if (`${serialize.ui.type}`.toLowerCase() === 'rectangle') this.__addRectangle(serialize)
    if (`${serialize.ui.type}`.toLowerCase() === 'polygon') this.__addPolygon(serialize)
    if (`${serialize.ui.type}`.toLowerCase() === 'ellipse') this.__addEllipse(serialize)
  }
  // serialize = { ui: {paths, fillColor, strokeColor} }
  __addPolygon(serialize) {
    if (!serialize || !serialize.ui) {
      console.warn("도형 정보가 올바르지 않습니다.", serialize);
      return;
    }

    const paths = serialize.ui.paths;
    const fillColor = serialize.ui.fillColor;
    const strokeColor = serialize.ui.strokeColor;
    if ( !paths || paths.length < 3 ) {
      console.warn("다각형 경로가 올바르지 않습니다.", paths);
      return;
    } else if ( !fillColor || !strokeColor ) {
      console.warn("다각형 색상 정보가 올바르지 않습니다.", fillColor, strokeColor);
      return;
    }

    const latLngPaths = (paths || []).map(p => new naver.maps.LatLng(p.lat, p.lng));
    const fill = this.__getAlphaFromHex(fillColor);
    const stroke = this.__getAlphaFromHex(strokeColor);

    const poly = new naver.maps.Polygon({
      map: this.map,
      paths: latLngPaths,
      fillColor: fill.hex,
      fillOpacity: fill.alpha,
      strokeColor: stroke.hex,
      strokeOpacity: stroke.alpha,
      strokeWeight: 3,
    });
    this.drawingManager.addDrawing(poly, naver.maps.drawing.DrawingMode.Polygon);
    this.drawingManager.trigger( naver.maps.drawing.DrawingEvents.ADD, poly, serialize);
  }
  // serialize = { ui: {bounds, fillColor, strokeColor} }
  __addRectangle(serialize) {
    if (!serialize || !serialize.ui) {
      console.warn("도형 정보가 올바르지 않습니다.", serialize);
      return;
    }

    const bounds = serialize.ui.bounds;
    const fillColor = serialize.ui.fillColor;
    const strokeColor = serialize.ui.strokeColor;
    if ( !bounds || bounds.length !== 4 ) {
      console.warn("사각형 경계 정보가 올바르지 않습니다.", bounds);
      return;
    }
    if ( !fillColor || !strokeColor ) {
      console.warn("사각형 색상 정보가 올바르지 않습니다.", fillColor, strokeColor);
      return;
    }

    const fill = this.__getAlphaFromHex(fillColor);
    const stroke = this.__getAlphaFromHex(strokeColor);
    const rect = new naver.maps.Rectangle({
      map: this.map,
      bounds,
      fillColor: fill.hex,
      fillOpacity: fill.alpha,
      strokeColor: stroke.hex,
      strokeOpacity: stroke.alpha,
      strokeWeight: 3,
    });
    this.drawingManager.addDrawing(rect, naver.maps.drawing.DrawingMode.RECTANGLE);
    this.drawingManager.trigger(
      naver.maps.drawing.DrawingEvents.ADD,
      rect,
      serialize
    );
  }
  // serialize = { ui: {latLngBounds, fillColor, strokeColor} }
  __addEllipse(serialize) {
    if (!serialize || !serialize.ui) {
      console.warn("도형 정보가 올바르지 않습니다.", serialize);
      return;
    }

    const latLngBounds = serialize.ui.latLngBounds;
    const fillColor = serialize.ui.fillColor;
    const strokeColor = serialize.ui.strokeColor;
    if ( !latLngBounds || !latLngBounds.sw || !latLngBounds.ne ) {
      console.warn("타원 경계 정보가 올바르지 않습니다.", latLngBounds);
      return;
    }
    if ( !fillColor || !strokeColor ) {
      console.warn("타원 색상 정보가 올바르지 않습니다.", fillColor, strokeColor);
      return;
    }

    const fill = this.__getAlphaFromHex(fillColor);
    const stroke = this.__getAlphaFromHex(strokeColor);
    const ellipse = new naver.maps.Ellipse({
      map: this.map,
      bounds: new naver.maps.LatLngBounds(
        new naver.maps.LatLng(latLngBounds.sw.lat, latLngBounds.sw.lng),
        new naver.maps.LatLng(latLngBounds.ne.lat, latLngBounds.ne.lng),
      ),
      fillColor: fill.hex,
      fillOpacity: fill.alpha,
      strokeColor: stroke.hex,
      strokeOpacity: stroke.alpha,
      strokeWeight: 3,
    });
    this.drawingManager.addDrawing(ellipse, naver.maps.drawing.DrawingMode.ELLIPSE);
    this.drawingManager.trigger(
      naver.maps.drawing.DrawingEvents.ADD,
      ellipse,
      serialize
    );
  }
  __isPointInsideShape(point, overlay) {
    if (!overlay || !point) return false;

    if (overlay instanceof naver.maps.Ellipse) {
      const bounds = overlay.serialize.ui.latLngBounds;
      const sw = bounds.sw
      const ne = bounds.ne
      const centerLat = (sw.lat + ne.lat) / 2;
      const centerLng = (sw.lng + ne.lng) / 2;
      const radiusX = (ne.lat - sw.lat) / 2;
      const radiusY = (ne.lng - sw.lng) / 2;
      const dx = point.lat - centerLat;
      const dy = point.lng - centerLng;
      return (dx*dx)/(radiusX*radiusX) + (dy*dy)/(radiusY*radiusY) <= 1;
    }

    if (overlay instanceof naver.maps.Rectangle) {
      const bounds = this.__boundsToPlain(overlay.getBounds && overlay.getBounds())
      const ne = { lat: bounds[1], lng: bounds[0] };
      const sw = { lat: bounds[3], lng: bounds[2] };
      const nw = { lat: sw.lat, lng: ne.lng };
      const se = { lat: ne.lat, lng: sw.lng };
      //return [sw, se, ne, nw];
      return (
        point.lat >= sw.lat &&
        point.lat <= ne.lat &&
        point.lng >= sw.lng &&
        point.lng <= ne.lng
      );
    }

    if (overlay instanceof naver.maps.Polygon) {
      const pathMVC = overlay.getPath && overlay.getPath();
      const pathArr = (pathMVC && typeof pathMVC.getArray === 'function') ? pathMVC.getArray() : (Array.isArray(pathMVC) ? pathMVC : []);
      const path = pathArr.map(p => this.__latLngToPlain(p));
      let x = point.lng, y = point.lat;
      let inside = false;
      for (let i = 0, j = path.length - 1; i < path.length; j = i++) {
        const xi = path[i].lng, yi = path[i].lat;
        const xj = path[j].lng, yj = path[j].lat;
        const intersect = ((yi > y) != (yj > y)) &&
          (x < (xj - xi) * (y - yi) / (yj - yi + 0.0000001) + xi);
        if (intersect) inside = !inside;
      }
      return inside;
    }

    return false;
  }
  __getPoints(overlay) {
    if (!overlay) return [];

    // Ellipse 와 Rectangle if 순서 주의
    if (overlay instanceof naver.maps.Ellipse) {
      let points = [];
      let steps = 20;
      const bounds = overlay.serialize.ui.latLngBounds;
      const centerLat = (bounds.sw.lat + bounds.ne.lat) / 2;
      const centerLng = (bounds.sw.lng + bounds.ne.lng) / 2;
      const radiusX = (bounds.ne.lat - bounds.sw.lat) / 2;
      const radiusY = (bounds.ne.lng - bounds.sw.lng) / 2;
      for (let i=0; i<steps; i++) {
        let theta = (2 * Math.PI / steps) * i;
        points.push({
          lat: centerLat + radiusX * Math.cos(theta),
          lng: centerLng + radiusY * Math.sin(theta)
        });
      }
      return points;
    }

    if (overlay instanceof naver.maps.Rectangle) {
      const bounds = this.__boundsToPlain(overlay.getBounds && overlay.getBounds())
      const ne = { lat: bounds[1], lng: bounds[0] };
      const sw = { lat: bounds[3], lng: bounds[2] };
      const nw = { lat: sw.lat, lng: ne.lng };
      const se = { lat: ne.lat, lng: sw.lng };
      return [sw, se, ne, nw];
    }

    if (overlay instanceof naver.maps.Polygon) {
      const pathMVC = overlay.getPath && overlay.getPath();
      const pathArr = (pathMVC && typeof pathMVC.getArray === 'function') ? pathMVC.getArray() : (Array.isArray(pathMVC) ? pathMVC : []);
      return pathArr.map(p => this.__latLngToPlain(p));
    }

    return [];
  }
  checkInsideTarget(overlay, movedPoints) {
    if (this.barrierOverlay) {
      const serialize = this.__serializeOverlay(overlay)
      const points = movedPoints || this.__getPoints(overlay);
      const valid = points.every(p => this.__isPointInsideShape(p, this.barrierOverlay));
      if (!valid) {
        if (this.outOfRange) {
          this.outOfRange();
        } else {
          alert("기준 영역을 벗어날 수 없습니다!");
        }
        this.map.setOptions("draggable", true);

        // 원래 위치로 되돌리기
        this.__restoreOverlayPosition(overlay);
        this.drawingManager.setOptions("drawingMode", naver.maps.drawing.DrawingMode.HAND);
      } else {
        this.changedOverlayPosition(overlay, serialize);
      }
    }
  }
  /**
   *
   */
  getOverlaysSerialize() {
    return this._overlays.map(o => o.serialize);
  }
  setBarrierOverlay(barrierOverlay) {
    this.barrierOverlay = barrierOverlay
  }
  setBarrierOverlayWithId(id) {
    if (!id) this.barrierOverlay = null;
    else if (this._overlays) {
      const overlay = this._overlays.find(o => o.serialize && o.serialize.data && o.serialize.data.id === id);
      if (overlay) {
        this.barrierOverlay = overlay;
      } else {
        this.barrierOverlay = null;
      }
    } else {
      this.barrierOverlay = null;
    }
    return this.barrierOverlay
  }
}
